import { NgModule } from '@angular/core'

import { ACCESS_TOKEN_SOURCE } from '@ti/core/contracts/access-token'
import { AUTH_SESSION } from '@ti/core/contracts/auth-session'
import { PROFILE } from '@ti/core/contracts/profile'

import { AuthSession } from './services/auth.session'
import { Profile } from './services/my.profile'

@NgModule({
  providers: [
    { provide: ACCESS_TOKEN_SOURCE, useExisting: AuthSession },
    { provide: AUTH_SESSION, useExisting: AuthSession },
    { provide: PROFILE, useExisting: Profile },
  ],
})
export class AuthModule {}
